<template>
  <hub-details />
</template>

<script setup lang="ts">
import { HubDetails } from '~/pages/_components/hub-details';
</script>
